import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./editerslideshow.css";
import { Delete_page } from "../delete_page";
import { Toast } from "../../components_root/ToastContext";
import { MdDeleteForever } from "react-icons/md";
const Editerslideshow = ({ slideshow_filedata, banner_default }) => {
  const { Toastshow } = Toast();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const intervalRef = useRef(null);
  const navigate = useNavigate();

  const totalSlides = slideshow_filedata?.length || 0;

  // Clear interval on unmount or when autoplay changes
  useEffect(() => {
    if (isAutoPlay && !isHovered && totalSlides > 0) {
      intervalRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
      }, 5000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [isAutoPlay, isHovered, totalSlides]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        goToPrevSlide();
      } else if (e.key === "ArrowRight") {
        goToNextSlide();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const goToNextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
    resetAutoplayTimer();
  }, [totalSlides]);

  const goToPrevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    resetAutoplayTimer();
  }, [totalSlides]);

  const goToSlide = useCallback((index) => {
    setCurrentSlide(index);
    resetAutoplayTimer();
  }, []);

  const resetAutoplayTimer = () => {
    if (isAutoPlay && !isHovered) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
      }, 5000);
    }
  };

  const toggleAutoplay = () => setIsAutoPlay((prev) => !prev);

  if (!slideshow_filedata || totalSlides === 0) return null;

  const current = slideshow_filedata[currentSlide];
  if (totalSlides === 0) {
    return (
      <div className="home-slideshow-container">
        <img
          src={banner_default}
          className="slide-image"
          alt="default banner"
        />
      </div>
    );
  }
  return (
    <div
      className="home-slideshow-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      role="region"
      aria-label="Image slideshow"
    >
      {/* Slides */}
      {slideshow_filedata.map((slide, index) => (
        <div
          key={index}
          className={`slide-wrapper ${index === currentSlide ? "active" : ""}`}


          tabIndex={0}
        // aria-label={`Go to ${slide.company} page`}
        >
          <img
            src={slide.fileurl || banner_default}
            alt={slide.title || slide.company}
            className="slide-image"
            loading={index === currentSlide ? "eager" : "lazy"}
          />


          {slide.title.length >= 1 && (
            <div className="company-info">
              <table className="b-bottom">
                <tr>
                  <td width={80}>
                    <div
                      className="button-ui2 cursor"
                      onClick={() => {
                        if (current && current.uid) {
                          Delete_page({
                            contentdata: "contentdata",
                            fileuid: slide.fileuid,
                            pageuid: slide.pageuid,
                            contentuid: slide.contentuid,
                            companyuid: slide.companyuid
                          }).then((res) => {
                            if (res.success) {
                              Toastshow("Deleted successfully");

                              // ✅ Remove from UI (IMPORTANT)
                              goToNextSlide();


                            } else {
                              Toastshow("Delete failed: " + res.error);
                            }
                          });
                        }
                      }}
                    ><MdDeleteForever className="icon" />
                      Delete
                    </div>
                  </td>
                  <td width={180} >
                    <div>
                      <div className="text-h3 " >Update:
                        {slide?.update_date_time
                          ? new Date(slide.update_date_time.seconds * 1000).toLocaleString()
                          : "-"}</div>

                    </div>
                  </td>
                  <td>
                    { }
                  </td>
                </tr>
              </table>
              <div className="text-hero m-top">{slide.title}</div>
              <div className="text-h1 line-h-35">{slide.description || ""}</div>
              {slide.button_link && slide.button_link.length > 1 && (
                <div
                  className="button-ui3 text-h2 p-22"
                  onClick={() => {
                    if (slide.button_link && slide.button_link.length > 1) {
                      if (slide.button_link.startsWith("http")) {
                        window.open(slide.button_link, "_blank");
                        return;
                      }
                      navigate("/" + slide.button_link);
                    }
                  }}
                >
                  {slide.button_name || "More Info"}
                </div>
              )}

            </div>
          )

          }

        </div>
      ))}

      {/* Navigation Arrows */}
      <button
        className="nav-arrow prev"
        onClick={goToPrevSlide}
        aria-label="Previous slide"
      >
        ‹
      </button>
      <button
        className="nav-arrow next"
        onClick={goToNextSlide}
        aria-label="Next slide"
      >
        ›
      </button>

      {/* Dots / Indicators */}
      <div className="dots" role="tablist" aria-label="Slide navigation">
        {slideshow_filedata.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
            aria-selected={index === currentSlide}
          />
        ))}
      </div>

      {/* Play/Pause Button */}
      <button
        className="play-pause"
        onClick={toggleAutoplay}
        aria-label={isAutoPlay ? "Pause slideshow" : "Play slideshow"}
      >
        {isAutoPlay ? "⏸" : "▶"}
      </button>


    </div>
  );
};

export default Editerslideshow;